import {useLocation} from '@reach/router';
import Layout from 'components/layout';
import SEO from 'components/seo';
import {Link} from 'gatsby';
import scrollTo from 'gatsby-plugin-smoothscroll';
import React, {useEffect, useRef} from 'react';
import Style from 'styles/service.module.scss';
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

import Image from '../components/image';

gsap.registerPlugin(ScrollTrigger);

const Service = () => {
  const location = useLocation();
  const containerRef = useRef(null);

  useEffect(() => {
    if (location.hash) {
      scrollTo(location.hash);
    }
  }, [location.hash]);

  useEffect(() => {
    const root = containerRef.current;
    if (!root) return;

    const imgs = root.querySelectorAll(`.${Style.serviceItemOutline__img}`);
    imgs.forEach((el) => {
      gsap.set(el, { opacity: 0, y: 60 });
      gsap.to(el, {
        opacity: 1,
        y: 0,
        duration: 1.0,
        ease: "power3.out",
        scrollTrigger: { trigger: el, start: "top 80%" },
      });
    });

    return () => ScrollTrigger.getAll().forEach((t) => t.kill());
  }, []);

  return (
    <Layout>
      <SEO title='Service' path='service' />
      <section className={Style.serviceIntro}>
        <div className={Style.serviceIntro__inner}>
          <div className={Style.serviceIntro__wrapper}>
            <div className={Style.serviceIntro__headWrapper}>
              <h2 className={Style.serviceIntro__head}>
                <span className={Style.serviceIntro__uppercase}>W</span>hat
                <br />
                <span className={Style.serviceIntro__uppercase}>W</span>e
                <br />
                <span className={Style.serviceIntro__uppercase}>O</span>ffer
              </h2>
            </div>
          </div>
        </div>
      </section>
      <section className={Style.serviceHeading}>
        <div className={Style.serviceHeading__inner}>
          <h1 className={Style.serviceHeading__title}>SERVICE</h1>
        </div>
      </section>
      <div className={Style.serviceContainer} ref={containerRef}>
        <div className={Style.serviceContainer__inner}>
          <div className={Style.serviceSes__inner} style={{paddingTop: 0}}>
            <div className={Style.serviceIntro__contentWrapper}>
              <div className={Style.serviceIntro__content}>
                <p>
                  イーゼのコンセプトは、イーコマースを最適化するという原点から自社開発以外にも様々な事案に取り組んでいます。
                </p>
                <p>
                  長年自社サービス開発を通して培ってきた、ユーザー、ステークホルダーのニーズなどをバックボーンとし、我々が成せるサービスやソリューションづくりに励み、一層高い価値の提供を目指しています。
                </p>
                <p>
                  市場や関係者様の要望に対し、イーゼ一丸となって、課題達成・問題解決、価値創造することに喜びと誇りを持ち、躍進します。
                </p>
              </div>
            </div>
          </div>
          <section className={Style.serviceSes} id="ses">
            <div className={Style.serviceSes__inner}>
              <div className={Style.serviceItem}>
                <div className={Style.serviceItem__header}>
                  <h2 className={Style.serviceItem__head}>PROJECTS</h2>
                </div>
                <div className={Style.serviceItemOutline}>
                  <div
                    className={Style.serviceItemOutline__img}
                  >
                    <Image filename="img_service_comachi.png" alt="コマチカート" />
                  </div>
                  <div className={Style.serviceItemOutline__txt}>
                    <h2 className={Style.serviceItemOutline__head}>自社開発のショッピングカートシステム</h2>
                    <p>
                      自社開発のショッピングカートシステム「comachicart(コマチカート)」はサービスインしたばかりの新しいショッピングカートシステムです。
                    </p>
                    <p>
                      豊富なデザインテンプレートを備え、多彩な機能でECサイトを簡単に構築。
                      直感的な操作性によりお客様のECサイト運営をサポートします。
                      パソコン、スマートフォン、タブレットなど様々な端末での表示に対応しており、HTMLやCSSの知識不要ですぐにお店を開くことができます。
                    </p>
                    <p>わかりやすくシンプルな料金体系で、初めてのECサイト開設でも安心です。</p>
                    <a href="https://www.comachicart.jp/" target="_blank" rel="noopener noreferrer">
                      <Image className={Style.serviceItemOutline__comachiBanner} filename='comachi_banner.png' />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className={Style.serviceSes} id='ses'>
            <div className={Style.serviceSes__inner}>
              <div className={Style.serviceItem}>
                <div className={Style.serviceItem__header}>
                  <h2 className={Style.serviceItem__head}>SYSTEM ENGINEERING SERVICE</h2>
                </div>
                <div className={Style.serviceItemOutline}>
                  <div
                    className={Style.serviceItemOutline__img}
                  >
                    <Image filename='e_ize_member_40.png' alt="優秀な人材をご提供" />
                  </div>
                  <div className={Style.serviceItemOutline__txt}>
                    <h2 className={Style.serviceItemOutline__head}>優秀な人材をご提供</h2>
                    <p>
                      WEBシステムの開発・検証・運用・保守といったサービス・ソリューションの提供には欠かせないエンジニア達を取引先へ提案し、技術的な
                      サービスを提供をしています。
                    </p>
                    <p>
                      単なるエンジニア派遣だけにとどまらず、日々蓄積・磨かれるITスキル、業界・業種別のノウハウ等を活用し、システムエンジニアリング内外にある課題解決を実践しています。
                    </p>
                    <p>
                      弊社では、技術スキルはもちろん、コミュニケーション力や従業員の士気も重視、フォローアップしており、人間力の高いエンジニアが提供できます。
                    </p>
                  </div>
                </div>
                <div className={Style.serviceItemOutline}>
                  <div
                    className={Style.serviceItemOutline__img}
                  >
                    <Image filename="e_ize_member_38.png" alt="SES実績" />
                  </div>
                  <div className={Style.serviceItemOutline__txt}>
                    <h2 className={Style.serviceItemOutline__head}>過去の実績</h2>
                    <p>
                      これまでWEBシステム開発をベースに、ECサイト構築、様々な業界におけるWEBシステム開発、SNSサービス開発、金融パッケージやグループウェア開発などを手掛けています。
                    </p>
                    <p>
                      フルスクラッチでの開発、レガシーなシステムのマイグレーション、エンハンス等も幅広く対応します。
                      このような実績の多くが下流工程から入る訳ではなく、要件やヒアリングフェーズから参画してます。
                    </p>
                    <p>数々の成功実績がさらに多くの業務機会を創出し、会社を一層成長させています。</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className={Style.serviceDevelopment} id='development'>
            <div className={Style.serviceDevelopment__inner}>
              <div className={Style.serviceItem}>
                <div className={Style.serviceItem__header}>
                  <h2 className={Style.serviceItem__head}>DEVELOPMENT</h2>
                </div>
                <div className={Style.serviceItemOutline}>
                  <div
                    className={Style.serviceItemOutline__img}
                  >
                    <Image filename='e_ize_member_24.png' alt="最大限のソリューション" />
                  </div>
                  <div className={Style.serviceItemOutline__txt}>
                    <h2 className={Style.serviceItemOutline__head}>最大限のソリューション</h2>
                    <p>イーゼでは自社製品の開発や受託開発も行っています。</p>
                    <p>
                      お客様のニーズや要求のヒアリングを通じて多角的な視点からソリューションをご提案するとともに、ご要望にマッチしたシステムの開発を行います。
                    </p>
                    <p>
                      また、納品して終了するのではなく、納品後のフォローやメンテナンス体制も整っており、お客様を全面的にサポートすることが可能です。
                    </p>
                  </div>
                </div>
                <div className={Style.serviceItemOutline}>
                  <div
                    className={Style.serviceItemOutline__img}
                  >
                    <Image filename="team.jpg" alt="受託開発実績" />
                  </div>
                  <div className={Style.serviceItemOutline__txt}>
                    <h2 className={Style.serviceItemOutline__head}>受託開発実績</h2>
                    <p>
                      これまで海外向け通信機器のレンタルアプリ開発、医療機関の予約システム開発、美容室向け予約システムのパフォーマンスチューニング、ブライダル業界の内部システムの開発などを請け負いました。
                    </p>
                    <p>SES事業を初めとする様々なプロジェクト経験があるエンジニアが開発を担います。</p>
                    <p>
                      自社製品のショッピングカートシステムcomachicart(コマチカート)や自社で使用する勤怠システムなど、
                      社内開発の経験から既にエンジニア組織が形成されているので円滑にプロジェクトを進行できることが私たちの強みです。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className={Style.serviceSes} id="ai-service">
            <div className={Style.serviceSes__inner}>
              <div className={Style.serviceItem}>
                <div className={Style.serviceItem__header}>
                  <h2 className={Style.serviceItem__head}>AI SERVICE</h2>
                </div>
                <div className={Style.serviceItemOutline}>
                  <div
                    className={Style.serviceItemOutline__img}
                  >
                    <Image filename="img_service_ai.png" alt="生成AI導入支援サービス" />
                  </div>
                  <div className={Style.serviceItemOutline__txt}>
                    <h2 className={Style.serviceItemOutline__head}>生成AI導入支援サービス</h2>
                    <p>
                      最先端のAIソリューションで、あなたのビジネスを加速する。
                    </p>
                    <p>
                      生成AI・AIエージェント・AIプラットフォーム・AIコンサルタント・AI研修まで、トータルサポートいたします。
                    </p>
                    <a href="https://ai.e-ize.jp/" target="_blank" rel="noopener noreferrer">
                      詳しくはこちら →
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </Layout>
  );
};

export default Service;
